module.exports = __webpack_public_path__ + "img/short-form-example-7.0b190872.png";